import axios from "axios";
import { useState, useEffect } from "react";

let current = new Date();
let dateTime =
  current.getFullYear() +
  "-" +
  (current.getMonth() + 1) +
  "-" +
  current.getDate() +
  " | " +
  current.getHours() +
  ":" +
  current.getMinutes() +
  ":" +
  current.getSeconds();

const useSheetForm = (validateInfo, sheetName) => {
  const [formData, setFormData] = useState({
    id: "INCREMENT",
    name: "",
    email: "",
    mobileNumber: "",
    orderId: "",
    message: "",
    timeStamp: dateTime,
  });

  const [subscribeFormData, setSubscribeFormData] = useState({
    id: "INCREMENT",
    timeStamp: dateTime,
    email: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");

  useEffect(() => {
    setTimeout(() => {
      setIsSubmitted(false);
    }, 5000);
  }, [isSubmitted]);

  //Setting input values to data state
  const handleChange = (e) => {
    if (
      e.target.name === "mobileNumber" &&
      !/^$|^[+-]?\d+$/.test(e.target.value)
    ) {
      return;
    }
    if (sheetName === "contactUs") {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    } else if (sheetName === "subscribeForm") {
      setSubscribeFormData({
        ...subscribeFormData,
        [e.target.name]: e.target.value,
      });
    }
  };

  //function to validate data on click of submit button
  const handleSubmit = (e) => {
    e.preventDefault();
    if (sheetName === "contactUs") {
      setErrors(validateInfo(formData));
    } else if (sheetName === "subscribeForm") {
      setErrors(validateInfo(subscribeFormData));
    }
    setIsSubmitting(true);
  };

  //checks for errors
  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      setIsSubmitted(true);

      // let data;
      // if (sheetName === "contactUs") {
      //   data = formData;
      // } else if (sheetName === "subscribeForm") {
      //   data = subscribeFormData;
      // }
      // axios
      //   .post(`${process.env.REACT_APP_BACKEND_LINK}/savesheetform`, {
      //     data,
      //     sheetName,
      //   })
      //   .then((res) => {
      //     // console.log(res);
      //     //   if(data === "contactUs"){
      //     setSubmitMessage(res.data);
      //     //   }else if(data === "subscribeForm"){
      //     //         set
      //     //   }
      //     setFormData({
      //       id: "INCREMENT",
      //       name: "",
      //       email: "",
      //       mobileNumber: "",
      //       orderId: "",
      //       message: "",
      //       timeStamp: dateTime,
      //     });
      //     setSubscribeFormData({
      //       id: "INCREMENT",
      //       timeStamp: dateTime,
      //       email: "",
      //     });
      //     setIsSubmitted(true);
      //   })
      //   .catch((err) => console.log(err));
      // console.log("Send to server");
      // setIsSubmitting(false);
    }
  }, [errors, isSubmitting, formData, sheetName]);

  return {
    handleChange,
    formData,
    subscribeFormData,
    handleSubmit,
    errors,
    isSubmitted,
    submitMessage,
  };
};

export default useSheetForm;
